import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import {Grid, Row, Col, Button} from 'react-bootstrap'
import {Link} from 'react-router'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import NotFound from '../Common/NotFound/NotFound'
import {getCurrentKeyword} from '../../utils/queryHelper'
import {IahoAddHorse, MdPerson} from '../Common/ReactIcons/icons'

import './Layout/SearchResult.css'
import BreederViewerBox from '../Common/BreederViewerBox/BreederViewerBox'

class BreederSearchResultScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      term: getCurrentKeyword(props.location.query, 'q'),
      page: 1,
      data: [],
      showMoreButton: false,
      hasNextPage: false,
      isLoading: true,
      showNotFound: false,
      nextPageData: []
    }

    this.nextPage = this.nextPage.bind(this)
    this.hideShowMoreAndLoadNextPage = this.hideShowMoreAndLoadNextPage.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.calculateHasNextPage = this.calculateHasNextPage.bind(this)
    this.searchRequest = this.searchRequest.bind(this)
    this.isNextPageData = this.isNextPageData.bind(this)
  }

  isNextPageData (data) {
    return this.state.page !== data
  }

  calculateHasNextPage (currentPage) {
    Actions.searchBreeder({term: this.state.term, page: parseInt(currentPage, 10) + 1}).then((res) => {
      this.setState({hasNextPage: true, nextPageData: res.data})
    }).catch(() => {
      this.setState({hasNextPage: false, nextPageData: []})
    })
  }

  handleScroll () {
    const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight
    const body = document.body
    const html = document.documentElement
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
    const windowBottom = windowHeight + window.pageYOffset
    if (windowBottom >= docHeight) {
      this.nextPage()
    }
  }

  componentWillMount () {
    if (this.props.search.breederResult.length > 0 && typeof (this.props.search.breederResult[0]) === 'object') {
      return this.setState({
        data: this.props.search.breederResult,
        hasNextPage: false,
        isLoading: false,
        term: this.props.search.keyword,
        showNotFound: false
      }, () => this.calculateHasNextPage(this.state.page))
    }
    this.searchRequest(false)
  }

  componentDidMount () {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  componentWillReceiveProps (nextProps) {
    const query = nextProps.location.query
    const state = this.state

    if (state.term !== getCurrentKeyword(query, 'q')) {
      this.setState({
        term: getCurrentKeyword(query, 'q'),
        page: 1
      }, () => {
        if (state.term !== getCurrentKeyword(query, 'q')) {
          return this.newSearchRequest()
        }
      })
    }
  }

  searchRequest (nextPage = false) {
    if (this.state.term === '') { return undefined }
    if (nextPage && !this.state.hasNextPage) { return undefined }

    Actions.searchBreeder({term: this.state.term, page: this.state.page}).then((res) => {
      this.setState({
        hasNextPage: false,
        isLoading: false,
        data: [...this.state.data, ...res.data],
        showNotFound: false},
        () => this.calculateHasNextPage(this.state.page))
    }).catch((error) => {
      this.setState({isLoading: false})
      if (error.response.status === 404) {
        this.setState({hasNextPage: false, showNotFound: true})
      }
    })
  }

  newSearchRequest () {
    this.setState({data: []}, () => {
      this.setState({isLoading: true})
      this.searchRequest()
    })
  }

  nextPage () {
    if (this.state.showMoreButton) {
      return undefined
    }

    if (this.state.hasNextPage) {
      let nextPage = this.state.page + 1
      this.setState({
        data: [...this.state.data, ...this.state.nextPageData],
        page: nextPage,
        showMoreButton: (nextPage % 3) === 0
      }, () => this.calculateHasNextPage(this.state.page))
    }
  }

  hideShowMoreAndLoadNextPage () {
    this.setState({showMoreButton: false})
    this.nextPage()
  }

  render () {
    const { isLoading, showMoreButton, showNotFound, data, term } = this.state
    return (
      <div className="SearchResult‌Breeder SearchResult">
        <div className="top-search-navigation">
          <Grid>
            <Row>
              <Col xs={5} md={2} lg={2}><h2 className="search-horse-title"><Link to={`/result?q=${term}`}><IahoAddHorse /> جستجوی اسب‌ها</Link></h2></Col>
              <Col xs={7} md={3} lg={2}><h2 className="active search-breeder-title"><MdPerson /> جستجوی پرورش‌دهنده‌ها</h2></Col>
            </Row>
          </Grid>
        </div>
        {isLoading ? <HorseLoading />
          : showNotFound ? <NotFound route={this.props.location} />
            : <Grid>
              <Row>
                {data.map((item, index) => (
                  <BreederViewerBox key={index} breeder={item} />
                  ))}
              </Row>
              <Row className="MoreButton">
                {showMoreButton && <Button bsStyle="info" onClick={this.hideShowMoreAndLoadNextPage} block>نمایش بیشتر...</Button>}
              </Row>
            </Grid>
        }
      </div>
    )
  }
}

BreederSearchResultScreen.fetchData = ({location}) => {
  return Actions.searchBreeder({term: location.query.q, page: 1})
}

function mapStateToProps (state) {
  return {
    search: state.search
  }
}

export default connect(mapStateToProps)(BreederSearchResultScreen)



// WEBPACK FOOTER //
// ./src/components/SearchResult/BreederSearchResultScreen.js